import { all, call, put, takeLatest } from '@redux-saga/core/effects';
import {
  formatErrorMessage,
  formatErrorMessageBaseOnCodeEmploymentStatus,
} from '../../util/helpers/registerRejectErrorCodeHelper';
import {
  GET_EMPLOYMENT_STATUS_LIST,
  GET_OCCUPATION_CATEGORIES,
  GET_OCCUPATION_CATEGORY_INFO,
  GET_EMPLOYMENT_INFO,
  CREATE_EMPLOYMENT_INFO,
  UPDATE_EMPLOYMENT_INFO,
  GET_INCOME_SOURCE_LIST,
} from '../actions/employmentStatus/employmentStatusActionConstants';
import {
  getEmploymentStatusListRequest,
  getOccupationCategoriesRequest,
  getOccupationCategoryInfoRequest,
  getEmploymentInfoRequest,
  postEmploymentInfoRequest,
  putEmploymentInfoRequest,
  getIncomeSourceRequest,
} from '../../request/employmentRequest';
import {
  getEmploymentStatusListSuccess,
  getEmploymentStatusListError,
  getOccupationCategoriesSuccess,
  getOccupationCategoriesError,
  getOccupationCategorySuccess,
  getOccupationCategoryError,
  getEmploymentInfoSuccess,
  getEmploymentInfoError,
  postEmploymentInfoSuccess,
  postEmploymentInfoError,
  putEmploymentInfoSuccess,
  putEmploymentInfoError,
  getIncomeSourceListSuccess,
  getIncomeSourceListError,
} from '../actions/employmentStatus/employmentStatusActions';

function* getEmploymentStatusList() {
  try {
    const { data } = yield call(getEmploymentStatusListRequest);
    if (data) {
      yield put(getEmploymentStatusListSuccess(data));
    }
  } catch (error) {
    const errMsg = formatErrorMessage(error);
    yield put(getEmploymentStatusListError(errMsg));
  }
}

function* getOccupationCategories() {
  try {
    const { data } = yield call(getOccupationCategoriesRequest);
    if (data) {
      yield put(getOccupationCategoriesSuccess(data));
    }
  } catch (error) {
    const errMsg = formatErrorMessage(error);
    yield put(getOccupationCategoriesError(errMsg));
  }
}

function* getOccupationCategoryInfo({ payload }) {
  try {
    const { data } = yield call(getOccupationCategoryInfoRequest, payload);
    if (data) {
      yield put(getOccupationCategorySuccess(data));
    }
  } catch (error) {
    const errMsg = formatErrorMessage(error);
    yield put(getOccupationCategoryError(errMsg));
  }
}

function* getEmploymentInfo({ payload }) {
  try {
    const { data } = yield call(getEmploymentInfoRequest, payload);
    if (data) {
      yield put(getEmploymentInfoSuccess(data));
    }
  } catch (error) {
    const errMsg = formatErrorMessage(error);
    yield put(getEmploymentInfoError(errMsg));
  }
}

function* createEmploymentInfo({ payload }) {
  try {
    const { data } = yield call(postEmploymentInfoRequest, payload);
    if (data) {
      yield put(postEmploymentInfoSuccess(data));
    } else {
      yield put(postEmploymentInfoSuccess(true));
    }
    if (payload?.onSuccess) {
      yield call(payload.onSuccess);
    }
  } catch (error) {
    const { fieldName, errorMessage } = yield call(
      formatErrorMessageBaseOnCodeEmploymentStatus,
      error,
    );
    yield put(postEmploymentInfoError(errorMessage));
    if (payload?.onError) {
      yield call(payload.onError, {
        type: 'manual',
        message: errorMessage,
        field: fieldName,
      });
    }
  }
}

function* updateEmploymentInfo({ payload }) {
  try {
    const { data } = yield call(putEmploymentInfoRequest, payload);
    if (data) {
      yield put(putEmploymentInfoSuccess(data));
    } else {
      yield put(putEmploymentInfoSuccess(true));
    }
    if (payload?.onSuccess) {
      yield call(payload.onSuccess);
    }
  } catch (error) {
    const { fieldName, errorMessage } = yield call(
      formatErrorMessageBaseOnCodeEmploymentStatus,
      error,
    );
    yield put(putEmploymentInfoError(errorMessage));
    if (payload?.onError) {
      yield call(payload.onError, {
        type: 'manual',
        message: errorMessage,
        field: fieldName,
      });
    }
  }
}

function* getIncomeSourceList() {
  try {
    const { data } = yield call(getIncomeSourceRequest);
    if (data) {
      yield put(getIncomeSourceListSuccess(data));
    }
  } catch (error) {
    const errMsg = formatErrorMessage(error);
    yield put(getIncomeSourceListError(errMsg));
  }
}

export default function* employmentSaga() {
  return yield all([
    takeLatest(GET_EMPLOYMENT_STATUS_LIST, getEmploymentStatusList),
    takeLatest(GET_OCCUPATION_CATEGORIES, getOccupationCategories),
    takeLatest(GET_OCCUPATION_CATEGORY_INFO, getOccupationCategoryInfo),
    takeLatest(GET_EMPLOYMENT_INFO, getEmploymentInfo),
    takeLatest(CREATE_EMPLOYMENT_INFO, createEmploymentInfo),
    takeLatest(UPDATE_EMPLOYMENT_INFO, updateEmploymentInfo),
    takeLatest(GET_INCOME_SOURCE_LIST, getIncomeSourceList),
  ]);
}
